import { APP_ENVIRONMENT_CONSTANTS } from 'common/constants/appEnvironmentConstants'
import { env } from 'common/utils/env'

const SCANNER_DEBUG = env.ENV === APP_ENVIRONMENT_CONSTANTS.DEVELOPMENT

const safeStringifyArg = (arg: unknown): string => {
  if (arg === null || arg === undefined) {
    return String(arg)
  }
  if (typeof arg === 'string') {
    return arg
  }
  if (typeof arg === 'number' || typeof arg === 'boolean' || typeof arg === 'bigint') {
    return String(arg)
  }
  if (arg instanceof Error) {
    return `${arg.name}: ${arg.message}`
  }
  try {
    return JSON.stringify(arg, (_key, value) => {
      if (typeof value === 'bigint') return value.toString()
      if (value instanceof Element) return `<${value.tagName.toLowerCase()}>`
      return value
    })
  } catch {
    return String(arg)
  }
}

const formatLogArgs = (args: unknown[]): string => args.map(safeStringifyArg).join(' ')

const forwardLogToServer = (level: 'info' | 'warn', message: string) => {
  if (typeof window === 'undefined' || typeof fetch === 'undefined') {
    return
  }
  try {
    void fetch('/__scanner_log', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ level, message }),
      keepalive: true,
    }).catch(() => undefined)
  } catch {
    return
  }
}

export const scannerLog = (...args: unknown[]) => {
  if (!SCANNER_DEBUG) return
  console.info('[scanner]', ...args)
  forwardLogToServer('info', formatLogArgs(args))
}

export const scannerWarn = (...args: unknown[]) => {
  if (!SCANNER_DEBUG) return
  console.warn('[scanner]', ...args)
  forwardLogToServer('warn', formatLogArgs(args))
}
